import React from "react";
import { BsXCircle,BsPlayCircle } from "react-icons/bs"; 
import ReactPlayer from "react-player";


const VideoHomePage = ()=>{
  const { http } = global.services;

  const [video, setVideos] = React.useState();
  const playerRef = React.useRef(null); 
  const [isPreviewing, setIsPreviewing] =React.useState(true);
  const [isPlayingFull, setIsPlayingFull] = React.useState(false);

  const getVid = React.useCallback(async()=>{ 
        let vidPlay = localStorage.getItem('vidPlayHP');
    
        try{
            if(vidPlay) {
                setVideos(null);
                return;
            };
            let { data } = await http.get(`public/announcementHomePage`);
            if(data){  
                console.log(data)
                setVideos(data)
            }
          }catch(e){
            console.error(e);
          } 
  },[http]);

  const hideVid = async()=>{
    localStorage.setItem('vidPlayHP', true);
    setVideos(null);
    try{
        await http.post(`public/user/acknowledgeLogged`,
          {
            announcementID:video?.id
          }
        );
      }catch(e){
        console.error(e);
      }
  }

  React.useEffect(()=>{ 
    getVid()
  },[getVid])

  const handlePlayFull = () => {
    setIsPreviewing(false);
    setIsPlayingFull(true);
    playerRef.current.seekTo(0); // Reset to start
  };

  const handleProgress = (progress) => {
    if (isPreviewing && progress.playedSeconds >= 5) {
      playerRef.current.seekTo(0);
    }
  };

    return (
        video?.url && (
            <div className="fixed bottom-4 right-4 bg-white w-[34vw] h-[44vh] z-[9999] rounded-xl shadow-md flex flex-col">
                <div className="flex justify-between p-4">
                <h2 className="font-bold text-xs sm:text-sm md:text-base lg:text-lg xl:text-xl">
                    Welcome to Milestones Pages!
                </h2>
                <div className="text-xl cursor-pointer" onClick={hideVid}>
                    <BsXCircle />
                </div>
                </div>
        
                {/* Video Section */}
                <div className="relative flex-1 bg-black px-4 flex items-center justify-center">
                <ReactPlayer
                     ref={playerRef}
                     url={video?.url}
                     playing={true}
                     muted={isPreviewing}
                     loop={isPreviewing}
                     controls={isPreviewing}
                     onProgress={handleProgress}
                     width="100%"
                     height="100%"
                />
        
                {!isPlayingFull  && (
                    <div
                    className="absolute z-10 cursor-pointer"
                    onClick={handlePlayFull}
                    >
                    <BsPlayCircle className="text-white text-6xl opacity-80 hover:opacity-100 transition-opacity" />
                    </div>
                )}
                </div>
        
                {/* Bottom Text */}
                <div className="text-center py-4">
                Already watched the video?{" "}
                <span className="font-semibold cursor-pointer text-primary decoration-solid" onClick={hideVid}>
                    Hide Video
                </span>
            </div>
        </div>
        )
    );
  
}

export default VideoHomePage;